import backendHttpClient from '@services/_httpClient/backend.http-client';

import type {
  UpdateRequesterDto,
  UpdateRequesterPayload,
} from './dtos/update.dto';
import type { RequesterRepository } from './repository';
import type {
  GetRequesterByIdOutput,
  GetRequesterByIdResponse,
} from './types/getById.type';
import type {
  UpdateRequesterOutput,
  UpdateRequesterResponse,
} from './types/update.type';

class RequesterService implements RequesterRepository {
  public async getById(id: string): Promise<GetRequesterByIdOutput> {
    const { data } = await backendHttpClient.get<GetRequesterByIdResponse>({
      path: `requesters/${id}`,
    });

    return { requester: data.requester };
  }

  public async update(
    payload: UpdateRequesterPayload,
  ): Promise<UpdateRequesterOutput> {
    const { data } = await backendHttpClient.put<
      UpdateRequesterResponse,
      UpdateRequesterDto
    >({
      path: `requesters/${payload.id}`,
      body: {
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
        phone: payload.phone,
        language: payload.language,
        serviceAtHomeAddress: payload.serviceAtHomeAddress,
        address: payload.address,
      },
    });

    return {
      requester: data.requester,
    };
  }
}

export const requesterService = new RequesterService();
